import { CreateMixin } from "@pdfking/reactivity/preact"
import uuid from "../utils/uuid"

export const IDMixin = CreateMixin({
  computed: {
    component_id: () => `cmp-${uuid()}`,
  },
})
